import { useQuery } from '@tanstack/react-query';

import { getUserSsn } from '@arrived/api_v2';
import { UserId } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { userSsnKeyFn } from './users.keys';

export function useGetUserSsnQuery(userId?: UserId, options?: UseQueryOptions<string>) {
  return useQuery(userSsnKeyFn(userId!), async () => getUserSsn(userId!), {
    ...options,
    enabled: (options?.enabled ?? true) && userId != null,
  });
}
